/**
 * =============================================================================
 * theme.js
 * =============================================================================
 * Entry point for all theme Javascript.
 * 
 * Before launching a site, consider what imports you actually need - i.e. which
 * parts of Bootstrap, which vendor JS imports, which Bootstrap plugins, etc.
 * =============================================================================
 */

// Imports from node_modules, installed via 'yarn add ...'
import $ from 'jquery'; // (~89Kb)
import * as bootstrap from 'bootstrap'; // (~97Kb)
import Swiper from 'swiper/swiper-bundle'; // (~144Kb)
import 'waypoints/lib/noframework.waypoints.min.js'; // (~10Kb)
import Cookies from 'js-cookie'; // (~2Kb)
import AOS from 'aos'; // Animate on Scroll (~14Kb) 

import Gauge from 'svg-gauge'; // Animated Gauges (~3Kb)
import hcSticky from 'hc-sticky'; // Sticky product gallery on desktop (~11Kb)
// import DepartureBoard from './departure-board'; // Departure board effect (~4Kb)

// Export for others scripts to use by attaching to the windowd
window.$ = $;
window.jQuery = $;
window.bootstrap = bootstrap;
window.Swiper = Swiper;
window.Cookies = Cookies;

window.Gauge = Gauge;
// window.DepartureBoard = DepartureBoard;

// Initialisation
AOS.init({
  once: true
});

// Imports from this folder - MP-specific
import MP from './mp';

import AutoAddProduct from './auto-add-product';
import BackInStock from './back-in-stock';
import Blog from './blog';
import Cart from './cart';
import Collection from './collection';
import ContentCollapse from './content-collapse';
import CookieBar from './cookie-bar';
import Facets from './facets';
// import FGWES from './fgwes';
// import FGWP from './fgwp';
import Localization from './localization';
import ProductFormManager from './product-form-manager';
import ProductModels from './product-models';
import ProductTileManager from './product-tile-manager';
import SizeChartSocks from './size-chart-socks';
import StickyPromoBanner from './sticky-promo-banner';
import Nav from './nav';
import Upsell from './upsell';

// Export for others scripts to use by attaching to the window
MP.Extensions.AutoAddProduct = AutoAddProduct; 
MP.Extensions.BackInStock = BackInStock;
MP.Extensions.Blog = Blog;
MP.Extensions.Cart = Cart;
MP.Extensions.Collection = Collection;
MP.Extensions.ContentCollapse = ContentCollapse;
MP.Extensions.CookieBar = CookieBar;
MP.Extensions.Facets = Facets;
// MP.Extensions.FGWES = FGWES;
// MP.Extensions.FGWP = FGWP;
MP.Extensions.Localization = Localization;
MP.Extensions.ProductFormManager = ProductFormManager;
MP.Extensions.ProductModels = ProductModels;
MP.Extensions.ProductTileManager = ProductTileManager;
MP.Extensions.SizeChartSocks = SizeChartSocks;
MP.Extensions.StickyPromoBanner = StickyPromoBanner;
MP.Extensions.Nav = Nav;
MP.Extensions.Upsell = Upsell;


// Debug
console.log('[T] jQuery version is', $.fn.jquery);

// Global functions
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.MP = Object.assign(MP, window.MP);
MP.init();